<div class="datasets-table">
  <div class="datasets-table-card">

   <!-- Added by Amisha on 2026-09-21.
        Reason: identify this non-application inline expansion by its parent page and active subtab on mobile. -->
   <wm-common-table
  #dataSetsTable
  tableType="Staff"
  [columns]="columns"
  [data]="rows"

  [isLoading]="loading"
  [loaderType]="'Circular'"
  [errorMessage]="errorMessage"
  [showRetryButton]="true"
  (retry)="loadDataSets()"

  expansionMode="inline"
  expandOn="cell"
  mobileInlineExpansionParentTitle="Reports"
  mobileInlineExpansionSubTabTitle="Data Sets"

  [expandedComponent]="datasetInfoComponent"
  [expandedComponentInputs]="getDatasetInfoInputs"
  [expandedComponentOutputs]="expandedComponentOutputs"
></wm-common-table>

  </div>
  <!-- <wm-modal-confirm title="Delete Data Set" [showButton]="false" commandText="Delete" (accepted)="deleteDataSet()"
    #deleteDataSetModal>
    <div>
      Are you sure you want to delete Data Set "{{ selectedDataSet?.name }}"?
    </div>
  </wm-modal-confirm> -->
  <!-- Start Code added by Sanchit 04/23/2026 -->
  <wm-common-confirmation-modal 
    [data]="modalData"
    (onYesClick)="confirmAction()"
    (onNoClick)="cancelAction()"
    [isApplicantMobileview]="true"
  >
    <ng-container *ngIf="currentAction === 'copy'">

      <!-- Jurisdiction Dropdown -->
      <wm-common-dropdown
        style="display:block; margin-bottom:16px;"
        [data]="clientDropdownData"
        (valueChange)="onClientChange($event)">
      </wm-common-dropdown>

      <!-- New Name Textfield -->
      <wm-common-textfield
        [data]="nameFieldData"
        (valueChange)="onNameChange($event)">
      </wm-common-textfield>

    </ng-container>
    
  </wm-common-confirmation-modal>
  <!-- End Code added by Sanchit 04/23/2026 -->

  <!-- <wm-modal-confirm title="Copy Data Set" [showButton]="false" commandText="Copy" (accepted)="copyDataSet()"
    #copyDataSetModal>
    <div>
      Are you sure you want to copy Data Set "{{ selectedDataSet?.name }}"?
    </div>

    <form [formGroup]="targetForm">
      <label class="bmd-label-static">Jurisdiction</label>

      <select class="form-control" formControlName="targetClientId" *ngIf="(clients || []).length > 1">

        <option value="" *ngIf="isSysAdmin">Global</option>

        <option *ngFor="let client of clients" [value]="client.id">
          {{ client.name }}
        </option>

      </select>

      <label class="bmd-label-static">New Name</label>

      <input type="text" formControlName="targetName" class="form-control" />
    </form>
  </wm-modal-confirm>

  <wm-modal-confirm title="Publish Data Set" [showButton]="false" commandText="Publish" (accepted)="publishDataSet()"
    #publishDataSetModal>
    <div>
      Are you sure you want to publish Data Set "{{ selectedDataSet?.name }}"?
    </div>
  </wm-modal-confirm> -->

</div>
